/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ServiceCost } from "./service-cost";
import { SiteSystem } from "./site-system";
import { Contact } from "./contact";

export class Site {
    id: number;
    name: string;
    address: string;
    address2: string;
    addressTown: string;
    addressCounty: string;
    addressPCode: string;
    addressLat: number;
    addressLng: number;
    parentContact: number;
    legacyData: number;
    motorisedSystems: number;
    manualSystems: number;
    dataVersion: number;
    serviceCost: ServiceCost;
    systems: SiteSystem[] = [];
    contacts: Contact[] = [];
    rowVersion: number[];
    nextMaintenanceDue: Date;
    postCodeStart: string = "UNKNOWN";
    fullAddress: string = "";
    searchAddress: string = "";
    searchAddressLower: string = "";
}
